import { Link } from "react-router-dom";
import GlassBottomNav from "../components/cliente/GlassBottomNav";
import FloatingCartBar from "../components/cliente/FloatingCartBar";

/**
 * Premium shell for the Cliente module. Replaces the legacy sidebar+topbar
 * on cliente routes only. Pages render their own headers (PremiumHeader).
 *
 * Drivers also have access to the shopping module ("Pedir") so they can
 * self-activate by purchasing — a return pill takes them back to their panel.
 */
export default function ClienteShell({ children }) {
  let isDriver = false;
  try {
    const u = JSON.parse(localStorage.getItem("user") || "null");
    isDriver = u?.user_type === "driver";
  } catch { /* ignore */ }

  return (
    <div className="min-h-screen bg-[#F8F8F8] text-[#1B1B1D]" data-testid="cliente-shell">
      {isDriver && (
        <Link
          to="/entregador/entregas"
          className="fixed top-3 right-3 z-50 flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-zinc-900/90 backdrop-blur-md border border-white/10 text-white text-[11px] font-extrabold shadow-lg"
          data-testid="driver-back-to-panel"
        >
          🛵 Painel Entregador
        </Link>
      )}
      <main className="pb-24">{children}</main>
      <FloatingCartBar />
      <GlassBottomNav />
    </div>
  );
}
